// extracted by mini-css-extract-plugin
module.exports = {"linkicon":"contactwidget_linkicon__oKaeh","container":"contactwidget_container__1prdP"};